export const typeFamille: Array<Object> = [
  {type: "maille",
    articles: [
      {code: ".*", famille: "213"},
      {code: "^17", famille: "299"},
      {code: "^65", famille: "299"},
    ]
  },
  {
    type: "blouse",
    articles: [
      {code: ".*", famille: "240"},
      {code: ".*", famille: "241"},
      {code: ".*", famille: "260"},
      {code: ".*", famille: "261"},
      {code: ".*", famille: "254"}
    ]
  },
  {
    type: "haut",
    articles: [
      {code: ".*", famille: "^25"},
      {code: ".*", famille: "262"},
      {code: "^54", famille: "299"},
      {code: "^55", famille: "299"},
      {code: "^59", famille: "299"}
    ]
  },
  {
    type: "pantalon",
    articles: [
      {code: ".*", famille: "^27"}
    ]
  },
  {
    type: "combinaison",
    articles: [
      {code: ".*", famille: "^23"},
      {code: "^3", famille: "299"}
    ]
  },
  {
    type: "gilet",
    articles: [
      {code: "^58", famille: "299"}
    ]
  }

];
